import { type AsyncNamespaceInput, type NexusHandler } from "@otto-ec/global-resources/nexus";
import { on } from "svelte/events";
import type { SnackbarV1 } from "./index.js";

const ALLOWED_TAG = "oc-link-v2";

export const openSnackbar = function openSnackbar(id: string) {
  const snackbar = document.getElementById(id) as HTMLOcSnackbarV1Element | null;
  if (!snackbar) return;

  snackbar.open = true;
} satisfies NexusHandler<SnackbarV1["open"]>;

export const closeSnackbar = function closeSnackbar(id: string) {
  const snackbar = document.getElementById(id) as HTMLOcSnackbarV1Element | null;
  if (!snackbar) return;

  snackbar.open = false;
} satisfies NexusHandler<SnackbarV1["close"]>;

export const closeAllSnackbars = function closeAllSnackbars() {
  const snackbars = document.querySelectorAll("oc-snackbar-v1");

  snackbars.forEach((snackbar) => {
    snackbar.open = false;
  });
} satisfies NexusHandler<SnackbarV1["closeAll"]>;

/**
 *
 *
 *
 *
 *
 */
export const prepareActionElement = (
  element: Element,
  children = element.querySelectorAll("*"),
): Element => {
  /*                                                                          */
  for (const node of [element, ...children]) {
    for (const attr of [...node.attributes]) {
      if (attr.name.startsWith("on")) (node as Element).removeAttribute(attr.name);
    }
  }

  element.setAttribute("slot", "actions");
  return element;
};

export const pushSnackbar = function pushSnackbar(
  message,
  { actions, classNames, ...options } = {},
) {
  const snackbar = document.createElement("oc-snackbar-v1");
  snackbar.message = message;
  /*                                                                                                        */
  Object.entries(options).forEach(([key, value]) => {
    snackbar[key] = value as never;
  });
  /*                                                                                                            */
  snackbar.open = true;

  if (classNames) {
    snackbar.classList.add(...classNames.split(" ").filter(Boolean));
  }

  if (actions) {
    const parsed = new DOMParser().parseFromString(actions, "text/html");
    const slot = document.createDocumentFragment();

    [...parsed.body.children]
      /*                                                               */
      .filter((el) => el.tagName.toLowerCase() === ALLOWED_TAG)
      .forEach((el) => slot.appendChild(prepareActionElement(el.cloneNode(true) as Element)));

    snackbar.appendChild(slot);
  }

  /*                                                 */
  document.body.append(snackbar);

  /*                                                                                        */
  /*                                  */
  on(snackbar, "oc-snackbar-close", () => setTimeout(() => snackbar.remove(), 500), { once: true });
} satisfies NexusHandler<SnackbarV1["push"]>;

/*                                                                               */
export const snackbarV1: AsyncNamespaceInput<OttoComponentApi["snackbarV1"]> = {
  open: openSnackbar,
  close: closeSnackbar,
  closeAll: closeAllSnackbars,
  push: pushSnackbar,
};
